import React, { } from "react";
import { Modal, Pagination, Search, Table, Header, Segment, Form, Button, Confirm, Icon, Radio, Checkbox } from 'semantic-ui-react';
import './reportPage.css';
import NoResultFound from "../../sharedComponent/noResultFound";
import { Constants } from "../../../config/appConstants";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

//const searchWithWhitespaceTrimmed = (options, query) => {
// return options.filter(opt => query.trim() === opt.text);
//};
const ReportPageComponent = props => {
  const myiconstyle = { color: "#f18f40", margin: "5px", cursor: "pointer" };
  return (
    <div>
      <Segment className="header-section">
        <Header as="h3">
          <Icon name="ellipsis horizontal"></Icon>
          <span>Schedule Reports</span>
        </Header>
        {props.user.claimValue.includes(Constants.BUTTON_CLAIMS.REPORT_ADD_BUTTON) &&
          <i aria-hidden="true"
            onClick={() => { props.onOpenModel({ data: {} }); }}
            style={myiconstyle} className="plus circle icon">
          </i>}
      </Segment>
      <div className="tableVertical">
        <Table striped celled className="ui table" style={{ marginTop: '1rem' }}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="tableCell"> </Table.HeaderCell>
              <Table.HeaderCell>Schedule Name
                <Search className="theader" onSearchChange={props.onReportSearch} name='scheduleName'
                  value={props.reportPage.srarchArray && props.reportPage.srarchArray.find(n => n.FieldName === 'scheduleName') && props.reportPage.srarchArray.find(n => n.FieldName === 'scheduleName').value}
                  placeholder={Constants.SEARCH_PLACEHOLDER} />
              </Table.HeaderCell>
              <Table.HeaderCell >Run
                <Search className="customeHeader" onSearchChange={props.onReportSearch} name='run'
                  value={props.reportPage.srarchArray && props.reportPage.srarchArray.find(n => n.FieldName === 'run') && props.reportPage.srarchArray.find(n => n.FieldName === 'run').value}
                  placeholder={Constants.SEARCH_PLACEHOLDER} />
              </Table.HeaderCell>
              <Table.HeaderCell>Report Time
                <Search className="reportTimeHeader" onSearchChange={props.onReportSearch} name='reportTime'
                  value={props.reportPage.srarchArray && props.reportPage.srarchArray.find(n => n.FieldName === 'reportTime') && props.reportPage.srarchArray.find(n => n.FieldName === 'reportTime').value}
                  placeholder={Constants.SEARCH_PLACEHOLDER} />
              </Table.HeaderCell>
              <Table.HeaderCell>Send Report To
                <Search className="theader" onSearchChange={props.onReportSearch} name='sendReportTo'
                  value={props.reportPage.srarchArray && props.reportPage.srarchArray.find(n => n.FieldName === 'sendReportTo') && props.reportPage.srarchArray.find(n => n.FieldName === 'sendReportTo').value}
                  placeholder={Constants.SEARCH_PLACEHOLDER} /></Table.HeaderCell>
              <Table.HeaderCell>Projects
                <Search className="theader" onSearchChange={props.onReportSearch} name='selectedProject'
                  value={props.reportPage.srarchArray && props.reportPage.srarchArray.find(n => n.FieldName === 'selectedProject') && props.reportPage.srarchArray.find(n => n.FieldName === 'selectedProject').value}
                  placeholder={Constants.SEARCH_PLACEHOLDER} />
              </Table.HeaderCell>
              <Table.HeaderCell>Divisions
                <Search className="theader" onSearchChange={props.onReportSearch} name='selectedDivision'
                  value={props.reportPage.srarchArray && props.reportPage.srarchArray.find(n => n.FieldName === 'selectedDivision') && props.reportPage.srarchArray.find(n => n.FieldName === 'selectedDivision').value}
                  placeholder={Constants.SEARCH_PLACEHOLDER} />
              </Table.HeaderCell>
              <Table.HeaderCell>Report Delegates
                <Search className="theader" onSearchChange={props.onReportSearch} name='reportDelegate'
                  value={props.reportPage.srarchArray && props.reportPage.srarchArray.find(n => n.FieldName === 'reportDelegate') && props.reportPage.srarchArray.find(n => n.FieldName === 'selectedProject').value}
                  placeholder={Constants.SEARCH_PLACEHOLDER} />
              </Table.HeaderCell>
              <Table.HeaderCell>Created By
                <Search className="theader" onSearchChange={props.onReportSearch} name='createdBy'
                  value={props.reportPage.srarchArray && props.reportPage.srarchArray.find(n => n.FieldName === 'createdBy') && props.reportPage.srarchArray.find(n => n.FieldName === 'createdBy').value}
                  placeholder={Constants.SEARCH_PLACEHOLDER} />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {props.reportPage.scheduleList && props.reportPage.scheduleList.length > 0 ? props.reportPage.scheduleList.map((data) => (
              <Table.Row verticalAlign="middle">
                {/* && (props.user.roleName !== Constants.CONTRIBUTE || (props.user.roleName === Constants.CONTRIBUTE && props.user.userId === data.createdById)) */}
                <Table.Cell className="ptb1 reportIcons">{props.user.claimValue.includes(Constants.BUTTON_CLAIMS.REPORT_EDIT_BUTTON) && <i aria-hidden="true" onClick={() => { props.onOpenModel({ data: data }); }} style={myiconstyle} className="edit pencil icon"></i>}
                  {(props.user.claimValue.includes(Constants.BUTTON_CLAIMS.REPORT_DELETE_BUTTON)) && <i aria-hidden="true" onClick={() => { props.onDeleteSchedule({ data: data }); }} style={myiconstyle} className="trash alternate outline icon"></i>}  </Table.Cell>
                <Table.Cell className="ptb1">{data.scheduleName}</Table.Cell>
                <Table.Cell className="ptb1" style={{ textTransform: 'capitalize' }}>{data.run}</Table.Cell>
                <Table.Cell className="ptb1">{data.runReportAt}</Table.Cell>
                <Table.Cell className="ptb1 issueNotes">{data.sendReportTo && data.sendReportTo.length > 0 && data.sendReportTo.map(a => (a.firstName != null || a.lastName != null) ? `${a.firstName} ${a.lastName}` : a.employeeName != null ? a.employeeName : a.employeeEmailAddress).join()}</Table.Cell>
                <Table.Cell className="ptb1 issueNotes">{data.projects && data.projects.length > 0 && data.projects.map(a => a && a.isAllProject ? "All Projects" : a.projectName).join()}</Table.Cell>
                <Table.Cell className="ptb1 issueNotes">{data.divisions && data.divisions.length > 0 && data.divisions.map(a => a && a.divisionName).join()}</Table.Cell>
                <Table.Cell className="ptb1 issueNotes">{data.reportDelegate && data.reportDelegate.length > 0 && data.reportDelegate.map(a => a && a.delegateUserName).join()}</Table.Cell>
                <Table.Cell className="ptb1">{data.userName}</Table.Cell>
              </Table.Row>
            )) :
              <Table.Row style={{ width: '100%' }}>
                <Table.Cell colSpan="7">
                  <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                </Table.Cell>
              </Table.Row>
            }
          </Table.Body>
        </Table>
      </div>
      <Modal closeIcon
        open={props.reportPage.isOpenModel}
        closeOnDimmerClick={false}
        onClose={() => { props.onCloseModel(); }}
      >
        <Modal.Header>Add Report</Modal.Header>
        <Modal.Content scrolling className="reportContent">
          <Form onSubmit={props.onSubmit}>
            <Form.Group inline widths='equal'>
              <Form.Field>
                <Form.Input required
                  maxLength="60"
                  label="Schedule Name"
                  placeholder='Schedule Name'
                  name='scheduleName'
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.scheduleName : ""}
                  onChange={props.handleFormChange} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "scheduleName") ? <span style={{ color: '#E0B4B4' }}>Schedule Name is required</span> : null}
              </Form.Field>

              <Form.Field>
                <Form.Input required
                  label="Description"
                  placeholder='Description'
                  name='description'
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.description : ""}
                  onChange={props.handleFormChange} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "description") ? <span style={{ color: '#E0B4B4' }}>Description is required</span> : null}
              </Form.Field>
            </Form.Group>
            <Form.Group inline widths='equal'>
              <Form.Field>
                <Form.Select
                  fluid required
                  label='Report Type'
                  name='reportType'
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.reportType : ""}
                  options={props.reportPage.reportType}
                  placeholder='select report'
                  onChange={props.handleFormChange} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "reportType") ? <span style={{ color: '#E0B4B4' }}>Report Type is required</span> : null}
              </Form.Field>
              <Form.Field>
                <Form.Select
                  fluid required
                  label='Run'
                  name='run'
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.run : ""}
                  options={props.reportPage.runPeriodOptions}
                  placeholder='select recurence'
                  onChange={props.handleFormChange}
                  disabled={props.reportPage.selectedData && props.reportPage.selectedTypeDayOrDate === Constants.DATE} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "run") ? <span style={{ color: '#E0B4B4' }}>Run is required</span> : null}
              </Form.Field>
            </Form.Group>
            <Form.Group inline widths='equal'>
              <Form.Field>
                <Form.Select
                  fluid search selection
                  required={props.reportPage.selectedData && props.reportPage.selectedData.run === "weekly" && props.reportPage.selectedData.scheduleHour !== Constants.NOW}
                  label='Day'
                  name='weekday'
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.weekday : ""}
                  options={props.reportPage.weekdays}
                  placeholder='Select day'
                  onChange={props.handleFormChange}
                  disabled={props.reportPage.selectedData && (props.reportPage.selectedData.run !== "weekly" || props.reportPage.selectedTypeDayOrDate === Constants.DATE || props.reportPage.selectedData.scheduleHour === Constants.NOW)}
                />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "weekday") ? <span style={{ color: '#E0B4B4' }}>Day is required</span> : null}
              </Form.Field>
              <Form.Field>
                <Form.Select
                  fluid search selection
                  required={props.reportPage.selectedData && props.reportPage.selectedData.run === "monthly" && props.reportPage.selectedData.scheduleHour !== Constants.NOW}
                  label='Date'
                  name='dateInMonth'
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.dateInMonth : ""}
                  options={props.reportPage.dates}
                  placeholder='Select Date'
                  onChange={props.handleFormChange}
                  disabled={props.reportPage.selectedData && (props.reportPage.selectedData.run !== "monthly" || props.reportPage.selectedTypeDayOrDate === Constants.DATE || props.reportPage.selectedData.scheduleHour === Constants.NOW)}
                />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "dateInMonth") ? <span style={{ color: '#E0B4B4' }}>Date is required</span> : null}
              </Form.Field>
            </Form.Group>
            <Form.Group>
              <Form.Field>
                <lable style={{ fontWeight: 'Bold', position: 'relative', left: '-10px' }}>Choose one option below to enter the Start and End date.</lable>
              </Form.Field>
              {[Constants.SYSTEM_ADMIN_ROLE_NAME, Constants.ADMIN_ROLE_NAME].includes(props.user.roleName) &&
                <Form.Field>
                  <Checkbox disabled={!props.reportPage.lastArchiveDate} checked={props.reportPage.isCheckedArchive} label={'Archive'} name="handleArchiveCheckboxChange" value={props.reportPage.isCheckedArchive} onChange={props.handleFormChange} />
                </Form.Field>
              }
            </Form.Group>
            <Form.Group>
              <Form.Field>
                <Radio style={{ position: 'relative', left: '-10px', fontWeight: '600' }}
                  label='Days'
                  name="selectedTypeDayOrDate"
                  value='DAY'
                  checked={props.reportPage.selectedTypeDayOrDate === Constants.DAY}
                  onChange={props.handleFormChange}
                />
              </Form.Field>
              <Form.Field>
                <Radio style={{ position: 'relative', left: '-10px', fontWeight: '600', left: '150px' }}
                  label='Date'
                  name="selectedTypeDayOrDate"
                  value='DATE'
                  checked={props.reportPage.selectedTypeDayOrDate === Constants.DATE}
                  onChange={props.handleFormChange}
                />
              </Form.Field>
            </Form.Group>
            {props.reportPage.selectedTypeDayOrDate == Constants.DATE &&
              <Form.Group inline widths='equal'>
                <Form.Field>
                  <lable style={{ fontWeight: 'Bold' }}>From Date</lable>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disabled={!props.reportPage.isDatePickerEnabled}
                      style={{ position: 'relative', left: '-20px' }}
                      className="issue-field w-100"
                      placeholder="MM/dd/yyyy"
                      name="selectedFromDate"
                      value={props.reportPage.selectedData.selectedFromDate}
                      inputProps={{ readOnly: true }}
                      onChange={date => props.handleDateChange(date, "selectedFromDate")}
                      format="MM/dd/yyyy"
                      {...(props.reportPage.minimumDate ? { minDate :  props.reportPage.minimumDate} : {})} 
                      {...(props.reportPage.calanderEndDate ? { maxDate :  props.reportPage.calanderEndDate} : {})} 
                    />
                  </MuiPickersUtilsProvider>
                  {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "selectedFromDate") ? <span style={{ color: '#E0B4B4' }}>From Date is required</span> : null}
                </Form.Field>
                <Form.Field>
                  <lable style={{ fontWeight: 'Bold' }}>To Date</lable>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disabled={!props.reportPage.isDatePickerEnabled}
                      style={{ position: 'relative', left: '-20px' }}
                      className="issue-field w-100"
                      placeholder="MM/dd/yyyy"
                      name="selectedToDate"
                      value={props.reportPage.selectedData.selectedToDate}
                      inputProps={{ readOnly: true }}
                      onChange={date => props.handleDateChange(date, "selectedToDate")}
                      format="MM/dd/yyyy"
                      {...(props.reportPage.minimumDate ? { minDate: props.reportPage.minimumDate } : {})}
                      {...(props.reportPage.calanderEndDate ? { maxDate: props.reportPage.calanderEndDate } : {})} 
                    />
                  </MuiPickersUtilsProvider>
                  {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "selectedToDate") ? <span style={{ color: '#E0B4B4' }}>To Date is required</span> : null}
                </Form.Field>
              </Form.Group>}
            <Form.Group inline widths='equal'>
              <Form.Field>
                <Form.Dropdown
                  disabled={props.reportPage.selectedData.reportType && props.reportPage.selectedData.reportType === "14" ? false : true}
                  fluid search selection multiple required
                  label='Division Number'
                  name='DivisionNumber'
                  value={props.reportPage && props.reportPage.selectedDivisionIds ? props.reportPage.selectedDivisionIds : ""}
                  options={props.reportPage.projectDivList}
                  placeholder='Select Division Number'
                  onChange={props.handleFormChange} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "DivisionNumber") ? <span style={{ color: '#E0B4B4' }}>Division is required</span> : null}
              </Form.Field>
            </Form.Group>
            {(props.reportPage && props.reportPage.disabledDivisionsList && props.reportPage.disabledDivisionsList.length > 0) &&
              <Form.Group inline widths='equal'>
                <Form.Field>
                  <Form.Dropdown
                    fluid selection multiple disabled
                    value={props.reportPage.disabledDivisionsList.map(p => p.value)}
                    options={props.reportPage.disabledDivisionsList} />
                  {<lable><span style={{ fontWeight: 'bold' }}>Note: </span><span>You don't have access to all divisions, contact <span style={{ fontWeight: 'bold' }}>{Constants.SUPPORT_MAIL_ADDRESS}</span> to get access to all divisions in this report</span></lable>}
                </Form.Field>

              </Form.Group>
            }
            <Form.Group inline widths='equal'>
              <Form.Field
                disabled={props.reportPage.selectedData && props.reportPage.selectedData.run === "daily" || props.reportPage.selectedTypeDayOrDate === Constants.DATE}>
                <label>Enter Start Date</label>
                <Form.Input
                  required={props.reportPage.selectedData && props.reportPage.selectedData.run !== "daily"}
                  label="[TODAY - ]"
                  placeholder='Enter Start Date'
                  name="startDate"
                  type='number'
                  min={0}
                  max={28}
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.startDate : ""}
                  onChange={props.handleFormChange} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "startDate") ? <span style={{ color: '#E0B4B4' }}>Start Date is required</span> : props.reportPage.invalidDataFields.some(e => e === "InvalidStartDate") ? <span style={{ color: '#E0B4B4' }}>{Constants.PLEASE_ENTER_VALID_START_DATE}</span> : null}
              </Form.Field>
              <Form.Field
                disabled={props.reportPage.selectedData && props.reportPage.selectedData.run === "daily" || props.reportPage.selectedTypeDayOrDate === Constants.DATE}>
                <label>Enter End Date</label>
                <Form.Input
                  required={props.reportPage.selectedData && props.reportPage.selectedData.run !== "daily"}
                  label="[TODAY - ]"
                  placeholder='Enter End Date'
                  name="endDate"
                  type='number'
                  min={0}
                  max={28}
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.endDate : 0}
                  onChange={props.handleFormChange} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "endDate") ? <span style={{ color: '#E0B4B4' }}>End Date is required</span> : props.reportPage.invalidDataFields.some(e => e === "InvalidEndDate") ? <span style={{ color: '#E0B4B4' }}>{Constants.PLEASE_ENTER_VALID_END_DATE}</span> : null}
              </Form.Field>
            </Form.Group>
            <Form.Group inline widths='equal'>
              <Form.Field>
                <Form.Select
                  fluid search selection required
                  label='Run report At (Hrs)'
                  name='scheduleHour'
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.scheduleHour : 0}
                  options={props.reportPage.hours}
                  placeholder='select run report at hour'
                  error={false}
                  onChange={props.handleFormChange}
                  disabled={props.reportPage.selectedData && props.reportPage.selectedTypeDayOrDate == Constants.DATE} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "scheduleHour") ? <span style={{ color: '#E0B4B4' }}>Run report At (Hr) is required</span> : null}
              </Form.Field>
              <Form.Field>
                <Form.Select
                  fluid search selection
                  label='Run report At (Min)'
                  name='scheduleMinute'
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.scheduleMinute : ""}
                  required={props.reportPage.selectedData && (props.reportPage.selectedData.scheduleHour < props.reportPage.maxHourLimit || props.reportPage.selectedData.scheduleHour !== Constants.NOW)}
                  disabled={props.reportPage.selectedData && (props.reportPage.selectedData.scheduleHour >= props.reportPage.maxHourLimit || props.reportPage.selectedTypeDayOrDate == Constants.DATE || props.reportPage.selectedData.scheduleHour === Constants.NOW)}
                  options={props.reportPage.minutes}
                  placeholder='select run report at minute'
                  onChange={props.handleFormChange} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "scheduleMinute") ? <span style={{ color: '#E0B4B4' }}>Run report At (Min) is required</span> : null}
              </Form.Field>
            </Form.Group>
            <Form.Group inline widths='equal'>
              <Form.Field>
                <Form.Dropdown
                  fluid search selection multiple required
                  disabled={props.reportPage.selectedData.reportType && props.reportPage.selectedData.reportType === "14" ? true : false}
                  label='Projects'
                  name='selectedProject'
                  value={props.reportPage && props.reportPage.selectedProjectIds ? props.reportPage.selectedProjectIds : ""}
                  options={props.reportPage.projectList}
                  placeholder='select Project'
                  onChange={props.handleFormChange} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "selectedproject") ? <span style={{ color: '#E0B4B4' }}>Project is required</span> : null}
              </Form.Field>
            </Form.Group>
            {(props.reportPage && props.reportPage.disabledProjectsList && props.reportPage.disabledProjectsList.length > 0) &&
              <Form.Group inline widths='equal'>
                <Form.Field>
                  <Form.Dropdown
                    fluid selection multiple disabled
                    value={props.reportPage.disabledProjectsList.map(p => p.value)}
                    options={props.reportPage.disabledProjectsList} />
                  {props.user.roleName != Constants.SYSTEM_ADMIN_ROLE_NAME && <lable><span style={{ fontWeight: 'bold' }}>Note: </span><span>You don't have access to all projects, contact <span style={{ fontWeight: 'bold' }}>{Constants.SUPPORT_MAIL_ADDRESS}</span> to get access to all projects in this report</span></lable>}
                </Form.Field>

              </Form.Group>
            }
            {(props.reportPage.selectedData && props.reportPage.taskInvolvedReports.includes(props.reportPage.selectedData.reportType)) &&
              <Form.Group inline widths='equal'>
                <Form.Field>
                  <Form.Dropdown
                    fluid search selection multiple required
                    label='Task codes'
                    name='selectedTaskcode'
                    value={props.reportPage && props.reportPage.selectedTaskcodeIds ? props.reportPage.selectedTaskcodeIds : ""}
                    options={props.reportPage.taskcodeList}
                    placeholder='select Taskcode'
                    onChange={props.handleFormChange} />
                  {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "selectedTaskcode") ? <span style={{ color: '#E0B4B4' }}>Taskcode is required</span> : null}
                </Form.Field>
              </Form.Group>
            }
            {(props.reportPage.selectedData && props.reportPage.taskInvolvedReports.includes(props.reportPage.selectedData.reportType) && props.reportPage && props.reportPage.disabledTaskCodesList && props.reportPage.disabledTaskCodesList.length > 0) &&
              <Form.Group inline widths='equal'>
                <Form.Field>
                  <Form.Dropdown
                    fluid selection multiple disabled
                    value={props.reportPage.disabledTaskCodesList.map(p => p.value)}
                    options={props.reportPage.disabledTaskCodesList} />
                </Form.Field>

              </Form.Group>
            }


            <Form.Group inline widths='equal'>
              <Form.Field>
                <Form.Dropdown
                  fluid search selection multiple allowAdditions
                  required={props.reportPage.selectedData && (!props.reportPage.sendListWithoutReport.includes(props.reportPage.selectedData.reportType))}
                  disabled={props.reportPage.selectedData && (props.reportPage.sendListWithoutReport.includes(props.reportPage.selectedData.reportType))}
                  label='Send to'
                  name='sendReportTo'
                  value={props.reportPage && props.reportPage.sendReportToId ? props.reportPage.sendReportToId : ""}
                  options={props.reportPage.employeeEmails}
                  placeholder='select report to'
                  renderLabel={(label) => ({
                    content: label.text,
                    icon: label.icon
                  })}
                  additionLabel={<i><Icon name="mail" />Add </i>}
                  onAddItem={props.handleAddition}
                  onChange={props.handleFormChange}
                />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "sendReportTo") ? <span style={{ color: '#E0B4B4' }}>Send To is required</span> : null}
              </Form.Field>
            </Form.Group>
            <Form.Group inline widths='equal'>
              <Form.Field>
                <Form.Input required
                  label="Subject"
                  placeholder='Subject'
                  name="subject"
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.subject : ""}
                  onChange={props.handleFormChange} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "subject") ? <span style={{ color: '#E0B4B4' }}>Subject is required</span> : null}
              </Form.Field>
              <Form.Field>
                <Form.Input required
                  label="Message"
                  placeholder='Message'
                  name="message"
                  value={props.reportPage.selectedData ? props.reportPage.selectedData.message : ""}
                  onChange={props.handleFormChange} />
                {props.reportPage.invalidDataFields && props.reportPage.invalidDataFields.some(e => e === "message") ? <span style={{ color: '#E0B4B4' }}>Message is required</span> : null}
              </Form.Field>
            </Form.Group>
            <Form.Group inline widths='equal'>
              <Form.Field>
                <Form.Dropdown
                  fluid selection search multiple
                  label='Report Delegates'
                  name='additionalReportDelegates'
                  value={props.reportPage && props.reportPage.reportDelegateIds ? props.reportPage.reportDelegateIds : ""}
                  options={props.reportPage.userEmails}
                  placeholder='select additional report delegates'
                  renderLabel={(label) => ({
                    content: label.text,
                    icon: label.icon
                  })}
                  onChange={props.handleFormChange}
                />
              </Form.Field>
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button primary disabled={!props.isValidateFormData(true)} onClick={() => { props.onSubmit(true); }}> Run now </Button>
          <Button primary disabled={!props.isValidateFormData()} onClick={() => { props.onSubmit(); }}> Save </Button>
          <Button secondary onClick={() => { props.onCloseModel(); }} > Back </Button>
        </Modal.Actions>
      </Modal>
      <Confirm
        closeIcon
        open={props.reportPage.isDeleteConfirm}
        content="Are you sure? Do you want to delete this Report?"
        header='Confirmation'
        size="tiny"
        onCancel={() => { props.onCancelDelete(); }}
        onConfirm={() => { props.onConfirmDelete(); }}
      />
      {props.reportPage.scheduleList && props.reportPage.scheduleList.length > 0 &&
        <Pagination floated="right"
          activePage={props.reportPage.pagination.activePage}
          onPageChange={props.onPageChange}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          totalPages={props.reportPage.pagination.totalCount} />
      }
    </div>

  );
}

export default ReportPageComponent;

ReportPageComponent.displayName = "ReportPageComponent";